import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getSpecialists } from "../../actions/especialistas";
import { getEncuestaResults } from "../../actions/surveys";
import Spinner from "../layout/Spinner";

const hasValidName = (value) => typeof value === "string" && value.trim() !== "";
const toSpecialistSlug = (nombres) =>
  (typeof nombres === "string" ? nombres : "").trim().replace(/\s+/g, "-");

const Terapeutas = ({
  auth,
  surveys,
  getSpecialists,
  specialists,
  getEncuestaResults,
}) => {
  const score = surveys?.initialSurvey?.respuestas.reduce((acc, res) => {
    acc[res] === undefined ? (acc[res] = 1) : (acc[res] += 1);
    return acc;
  }, {});

  const group = score
    ? Object.keys(score).reduce((acc, key) => (score[key] > acc ? key : acc), 0)
    : null;

  const filterRecommended = (id) =>
    auth.user?.sessions?.length > 0
      ? id === auth.user.sessions[auth.user.sessions.length - 1].especialista
      : group && score[group] >= 3
      ? group === "resp1"
        ? id === "6116c21d6425154ad40cd694" ||
          id === "620abc296425154ad40db810" ||
          id === "61528af86425154ad40d2665" ||
          id === "60b62d8c039d42143b9e5d08"
        : group === "resp2"
        ? id === "5f6dfd7083615f65740919c7" ||
          id === "607f025cfe2134662f15c238" ||
          id === "60e7970de989315812a40908" ||
          id === "5f3d51b29871617c2d4bc740"
        : id === "5f3b14b00011c31eaaa96872" ||
          id === "6090d2bffe2134662f15c32d" ||
          id === "611440f36425154ad40cd354"
      : id === "5f3b14b00011c31eaaa96872" ||
        id === "607f025cfe2134662f15c238" ||
        id === "5f6dfd7083615f65740919c7" ||
        id === "611440f36425154ad40cd354";
  useEffect(() => {
    getSpecialists();
    getEncuestaResults({ id: auth.user?._id });
  }, [getSpecialists, getEncuestaResults, auth.user]);

  return (
    <section
      className="flex-grow flex flex-col mx-auto font-sans mb-6 w-full"
      styles={{ height: "max-content" }}
    >
      <div className="w-full relative">
        <div className="mx-auto text-center text-white bg-higia-azul">
          <div className="container mx-auto px-8">
            <h2 className="pt-4 md:pt-12 text-3xl font-extrabold mx-3">
              ¡Ellos están aquí para ti!
            </h2>
            <p className="text-2xl font-bold mx-3">
              Dispuestos a escucharte y ayudarte
            </p>
          </div>
        </div>
        <div
          className="text-higia-azul overflow-hidden relative"
          style={{ top: "-2px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
            className="fill-current shadow-lg w-full wavesShadow"
            preserveAspectRatio="none"
          >
            <path d="M0,128L80,138.7C160,149,320,171,480,154.7C640,139,800,85,960,85.3C1120,85,1280,139,1360,165.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
          </svg>
        </div>
      </div>

      <div className="container mx-auto px-8 ">
        {specialists.loading || !specialists.specialists ? (
          <Spinner />
        ) : (
          <>
            <div className="bg-higia-bermuda -mx-10 px-8 pt-6 pb-5 lg:-mx-3 lg:pt-5 lg:px-8 rounded-lg shadow-lg">
              <div className="text-white text-2xl font-bold underline">
                Recomendados para ti
              </div>
              {specialists.specialists
                .filter(
                  (specialist) =>
                    hasValidName(specialist.nombres) &&
                    filterRecommended(specialist._id)
                )
                .map((specialist, id) =>
                  specialist.isInactive ? null : (
                    <TerapeutaCard info={specialist} key={id} />
                  )
                )}
            </div>
            {specialists.specialists
              .filter(
                (specialist) =>
                  hasValidName(specialist.nombres) &&
                  !filterRecommended(specialist._id)
              )
              .map((specialist, id) =>
                specialist.isInactive ? null : (
                  <TerapeutaCard info={specialist} key={id} />
                )
              )}
          </>
        )}
      </div>
    </section>
  );
};

const TerapeutaCard = ({ info }) => {
  // Parse credentials from longDesc if available
  const credentials = info.credentials || [];
  const specialistName = hasValidName(info.nombres)
    ? info.nombres
    : "Especialista";
  const specialistSlug = toSpecialistSlug(info.nombres);

  return (
    <Link
      to={`/terapeutas/${specialistSlug}`}
      className="block"
    >
      <div className="bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 mt-4 mb-0 md:mb-3 border border-gray-100 hover:border-higia-bermuda cursor-pointer">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <img
              className="h-16 w-16 object-cover rounded-full ring-2 ring-gray-100"
              src={info.avatar}
              alt={`Foto de ${specialistName}`}
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="mb-2">
              <h4 className="text-lg mb-1">
                <span className="text-higia-cyan font-normal">Hola</span>
                <span className="text-gray-900 font-normal">, soy</span>
              </h4>
              <h3 className="text-xl font-bold text-gray-900 mb-1">
                {specialistName}
              </h3>
              {info.cpsp && (
                <p className="text-gray-600 text-xs mb-2">
                  cpsp: {info.cpsp}
                </p>
              )}
              <div className="flex gap-1 mb-2">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-4 h-4 fill-current text-higia-cyan"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                ))}
              </div>
            </div>

            {credentials.length > 0 ? (
              <ul className="space-y-2 mb-2">
                {credentials.map((credential, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <div className="flex-shrink-0 mt-0.5">
                      <div className="w-4 h-4 rounded-full bg-higia-cyan flex items-center justify-center">
                        <svg
                          className="w-2.5 h-2.5 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={3}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                    </div>
                    <p className="text-gray-700 text-sm leading-relaxed flex-1">
                      {credential}
                    </p>
                  </li>
                ))}
              </ul>
            ) : info.longDesc ? (
              <div className="mb-2">
                <p className="text-gray-700 text-sm leading-relaxed">
                  {info.longDesc}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Link>
  );
};

const mapStateToProps = (state) => ({
  specialists: state.specialists,
  surveys: state.surveys,
  auth: state.auth,
});

export default connect(mapStateToProps, { getSpecialists, getEncuestaResults })(
  Terapeutas
);
